module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/flag/flag.component.scss
// module id = ./src/app/features/flag/flag.component.scss
// module chunks = main